import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DisplayType } from 'src/app/core/interfaces/app.interface';
import { NgClass } from '@angular/common';
import { DisableContextMenuDirective } from 'src/app/core/directives/disable-context-menu.directive';
import { WithFallbackImageDirective } from '../../../directives/with-fallback-image.directive';

@Component({
  selector: 'collection-icon',
  templateUrl: './collection-icon.component.html',
  styleUrls: ['./collection-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, DisableContextMenuDirective, WithFallbackImageDirective],
})
export class CollectionIconComponent {
  @Input() enablePointerCursorHoverIcon: boolean = true;
  @Input({ required: true }) icons: string[] = [];
  @Input({ required: false }) displayType: DisplayType = DisplayType.BIG;
  @Output() iconClicked: EventEmitter<void> = new EventEmitter<void>();

  iconsGrid = [0, 1, 2, 3];

  protected handleClick() {
    this.iconClicked.emit();
  }

  protected readonly DisplayType = DisplayType;
}
